// Duration formatters shared by the tool-call progress derivation and the group
// card. Pure functions of a millisecond duration — no locale, no timezone.

// Compact elapsed time from a millisecond duration: "0s" / "45s" / "2m 05s" / "1h 04m".
// Use for: live run timers and other "time since started" readouts where
// seconds matter. Returns "0s" on invalid input.
// Don't use for: calendar time-ago strings.
export const getPrettyElapsedShort = ms => {
  if (ms == null || !Number.isFinite(ms) || ms < 0) return '0s';
  const totalSec = Math.floor(ms / 1000);
  if (totalSec < 60) return `${totalSec}s`;
  const m = Math.floor(totalSec / 60);
  if (m < 60) return `${m}m ${String(totalSec % 60).padStart(2, '0')}s`;
  const h = Math.floor(m / 60);
  return `${h}h ${String(m % 60).padStart(2, '0')}m`;
};

// Duration with debugging-grade precision at the fast end ("412ms", "2.1s"),
// deferring to the coarse elapsed buckets past ten seconds. Null on invalid input.
export const getPrettyDurationPrecise = ms => {
  if (ms == null || !Number.isFinite(ms) || ms < 0) return null;
  if (ms < 1000) return `${Math.round(ms)}ms`;
  if (ms < 10000) return `${(ms / 1000).toFixed(1)}s`;
  return getPrettyElapsedShort(ms);
};

// Coarse "time left" magnitude for live progress ETAs: "under a minute" /
// "a minute" / "3 minutes" / "an hour". The caller frames it ("About <x>
// left"); buckets are deliberately rough — a glance, not a countdown.
// Returns null on invalid input.
export const getPrettyTimeLeftShort = ms => {
  if (ms == null || !Number.isFinite(ms) || ms < 0) return null;
  const minutes = Math.round(ms / 60000);
  if (minutes <= 0) return 'under a minute';
  if (minutes === 1) return 'a minute';
  if (minutes < 60) return `${minutes} minutes`;
  const hours = Math.round(minutes / 60);
  return hours === 1 ? 'an hour' : `${hours} hours`;
};
